import "views/hidden/loaders.css"


const LoadersChecker = () => {

    return (
        <>
        <h1>Check loaders</h1>
            <div className="container-fluid">
                {
                    /*


                <div className="row">
                    <div className="col-12">
                        <h5>Loader 1</h5>
                        <div className="loader-1"></div>
                    </div>
                </div>
                <div className="rowp pt-5">
                    <div className="col-12">
                        <h5>Loader 2</h5>
                        <div className="loader-2"></div>
                    </div>
                </div>
                <div className="rowp pt-5">
                    <div className="col-12">
                        <h5>Loader 3</h5>
                        <div className="loader-3"></div>
                    </div>
                </div>
                <div className="rowp pt-5">
                    <div className="col-12">
                        <h5>Loader 4</h5>
                        <div className="loader-circular">
                        </div>
                    </div>
                </div>
                <div className="rowp pt-5">
                    <div className="col-12">
                        <h5>Loader 5</h5>
                        <div className="loader-5">
                        </div>
                    </div>
                </div>
                 */
                }

                <div className="rowp pt-5">
                    <div className="col-12">
                        <h5>Loader 5</h5>
                        <div id="preloader">
                            <div id="loader-6"></div>
                        </div>
                    </div>
                </div>


            </div>
        </>
    )
}

export default LoadersChecker